import React  from 'react';

export const addOrganizationConfig = [
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/user-management-organisations/add-organisation',
        component: React.lazy(() => import('./NewOrganization')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/user-management-organisations/edit',
        component: React.lazy(() => import('./OrganizationTabs')),
      },
    ],
  },  
  
];
